// extracted by mini-css-extract-plugin
export default {"mainContent":"styles_mainContent__bNU0o","formConteiner":"styles_formConteiner__y7WWR","formWrapper":"styles_formWrapper__d1O3O","languageSwitcher":"styles_languageSwitcher__YJK6l"};